import React from 'react';
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const IntlMessage = ({ id, fallback }) => {

	const { t } = useTranslation()

	const translate = t(id, fallback)

	return <>{translate}</>
}

IntlMessage.propTypes = {
  id: PropTypes.string.isRequired,
  fallback: PropTypes.string
}

export default IntlMessage;
